import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "Send request to CBP/Partners", -1)
const _hoisted_2 = { class: "send-to-partner-box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "box-title" }, "Send a request", -1)
const _hoisted_4 = { class: "blue-box" }
const _hoisted_5 = { class: "mb-20 d-flex flex-column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "label-ui" }, "Send to", -1)
const _hoisted_7 = { class: "d-flex flex-column mb-20" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "label-ui" }, "Email", -1)
const _hoisted_9 = { class: "tags-wrapper mb-20" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "label-ui" }, "Tags", -1)
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { class: "d-flex flex-column mb-10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "label-ui" }, "Message", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "d-flex align-items-end flex-wrap" }
const _hoisted_16 = {
  class: "mb-10 mr-20",
  style: {"width":"calc(50% - 10px)"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "select-label" }, "Reminders", -1)
const _hoisted_18 = {
  class: "mb-10",
  style: {"width":"calc(50% - 10px)"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "select-label" }, "Secure URL expiration", -1)
const _hoisted_20 = { class: "d-flex flex-row-reverse" }
const _hoisted_21 = { class: "confirm-modal-description" }
const _hoisted_22 = { class: "mb-20" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", { class: "confirm-modal-label" }, "Details:", -1)
const _hoisted_24 = { class: "confirm-modal-value" }
const _hoisted_25 = {
  key: 0,
  class: "mb-20"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h4", { class: "confirm-modal-label" }, "Behavior:", -1)
const _hoisted_27 = { class: "confirm-modal-value" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"500px"} }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, "Your request has been sent.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_select_input = _resolveComponent("select-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_white_box_main = _resolveComponent("white-box-main")!
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    "header-left": _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_white_box_main, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.selectedPartners,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPartners) = $event)),
                  options: _ctx.partnersOptions,
                  multiple: false,
                  "close-on-select": true,
                  "clear-on-select": false,
                  "preserve-search": true,
                  placeholder: "Select partners",
                  label: "name",
                  "track-by": "name",
                  "preselect-first": false
                }, {
                  selection: _withCtx(({ values, isOpen }) => [
                    (values.length)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "multiselect__single"
                        }, _toDisplayString(values.map(el => el.name).join(', ')), 513)), [
                          [_vShow, !isOpen]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                  class: "base-input black",
                  type: "email"
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", {
                    class: "tag",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.message += ' [partner_name] '))
                  }, "Partner name"),
                  _createElementVNode("span", {
                    class: "tag",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.message += ' [password] '))
                  }, "Password"),
                  _createElementVNode("span", {
                    class: "tag",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.message += ' [expire_in] '))
                  }, "Expire in"),
                  _createElementVNode("span", {
                    class: "tag",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.message += ' [url] '))
                  }, "Url")
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("textarea", {
                  class: "textarea mb-10",
                  value: _ctx.message,
                  rows: "8",
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleInputChange($event.target.value)))
                }, null, 40, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_select_input, {
                    class: "min-width-180",
                    value: _ctx.reminder,
                    "show-close-button": false,
                    placeholder: "Select",
                    options: [
                  {label: 'No Reminder', value: '0'},
                  {label: '1 Time', value: '1'},
                  {label: '2 Times', value: '2'},
                  {label: '3 Times', value: '3'},
                  ],
                    onHandleChange: _cache[7] || (_cache[7] = (v) => {_ctx.reminder = v})
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_select_input, {
                    class: "min-width-180",
                    value: _ctx.expires,
                    "show-close-button": false,
                    options: [
                  {label: 'Expires in 12 hours', value: 12},
                  {label: 'Expires in 1 day', value: 24},
                  {label: 'Expires in 2 days', value: 48},
                  {label: 'Expires in 5 days', value: 120},
                ],
                    onHandleChange: _cache[8] || (_cache[8] = (v) => {_ctx.expires = v})
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_base_button, {
                  disabled: (_ctx.selectedPartners === null) || (_ctx.email === ''),
                  class: "mb-10 mt-24 button-send-now",
                  onClick: _ctx.openSendNowModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Send Now")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.confirmModal.isOpen.value,
        "min-width": 600,
        onOnCancel: _ctx.confirmModal.close,
        onOnConfirm: _ctx.onSendNow
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("p", _hoisted_24, "You are sending a request for information to " + _toDisplayString(_ctx.email) + " for " + _toDisplayString(_ctx.selectedPartners.name), 1)
              ]),
              (_ctx.reminder !== '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("p", _hoisted_27, "They will be reminded to complete their information " + _toDisplayString(_ctx.reminder) + " time in " + _toDisplayString(_ctx.expires) + " hours.", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, { onClick: _ctx.onSendNow }, {
            default: _withCtx(() => [
              _createTextVNode("Yes, confirm")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_base_button, {
            variant: "outlined",
            class: "mr-20",
            onClick: _ctx.confirmModal.close
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["is-visible", "onOnCancel", "onOnConfirm"]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.successModal.isOpen.value,
        onOnCancel: _ctx.successModal.close,
        onOnConfirm: _ctx.successModal.close
      }, {
        content: _withCtx(() => [
          _hoisted_28
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, { onClick: _ctx.closeSuccessModalAndResetValues }, {
            default: _withCtx(() => [
              _createTextVNode("Done")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["is-visible", "onOnCancel", "onOnConfirm"])
    ]),
    _: 1
  }))
}